// let's create a custom element that will handle the card media order
if (!window.customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      document.addEventListener('ProductBlockManagerImagesLoaded', this.loadMetal.bind(this));
      const mediaList = Array.from(this.querySelectorAll('[data-image-src-order]'));
      const parentEl = mediaList[0].parentElement;
      mediaList.sort((a, b) => a.dataset.imageSrcOrder - b.dataset.imageSrcOrder);
      mediaList.forEach((media) => {
        parentEl.appendChild(media);
      });

    }

    loadMetal() {
      setTimeout(() => {
        const metal = this.dataset.selectedMetal;
        //console.log('metal', metal);
        const metalSpan = this.querySelector(`[data-option-item="${metal}"]`);
        //console.log('metalSpan', metalSpan);
        if (metalSpan) {
          //metalSpan.dispatchEvent(new Event("mouseover", {bubbles: true}))
        }
      }, 1);
    }
  }

  window.customElements.define('product-card', ProductCard);
}
